
import { Button } from "@progress/kendo-react-buttons";
import { useTranslation } from "react-i18next";

interface GxTertiaryButtonProps {
  handleClose: () => void;
  label?: string;
}
const GxTertiaryButton: React.FC<GxTertiaryButtonProps> = ({
  handleClose,
  label ="",
}) => {
  const { t } = useTranslation();
  return (
    <Button
      type="button"
      onClick={handleClose}
      className="gx-dialog-back-button gx-p12-eb">
      <span className="gx-p12-eb">{t(label)}</span> 
    </Button>
  );
};

export default GxTertiaryButton;
